import React from 'react';
import './PlaceholderPage.css';

const ShopifySettingsPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">Shopify Settings</h1>
      <p className="page-description">
        Shopify configuration including publishing, metafields, shipping, and location settings will be added here.
      </p>
      
      <div className="settings-list">
        <div className="setting-item">
          <span className="setting-label">Default Publish Set</span>
          <span className="setting-status">Not configured</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Metafields Mapping</span>
          <span className="setting-status">Not configured</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Shopify Mapping</span>
          <span className="setting-status">Not configured</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Create Custom Metafields</span>
          <span className="setting-status">Not configured</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Shipping Required</span>
          <span className="setting-status">Not set</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Location Set</span>
          <span className="setting-status">Not configured</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Vendor List</span>
          <span className="setting-status">Not configured</span>
        </div>
      </div>
    </div>
  );
};

export default ShopifySettingsPage;
